<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="频道名称">
              <el-input v-model="queryParams.name" @change="search" @clear="search" placeholder="请输入频道名称"
                clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="addNoNe" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" size="medium"
        :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }" :cell-style="{ textAlign: 'center' }"
        @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column label="优化师ID">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="频道名称">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="name" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>隐藏</el-tag>
          </template>
        </el-table-column>
       
        <el-table-column prop="name" label="权重" >
          <template slot-scope="scope">
            <el-tooltip placement="bottom" v-if="showWeight[scope.$index]">
              <div slot="content" v-html="clickText"></div>
              <span class="description-span" @click="setToNumber(scope.$index, scope.row.id)">{{ scope.row.sequence
                }}</span>
            </el-tooltip>
            <el-input class="custom-input" v-if="!showWeight[scope.$index]" v-model="scope.row.sequence"
              @blur="editShowWeight(scope.$index)" @change="editWeight(scope.$index, scope.row)"
              @input="validateInput(scope.row)" style="width: 60%;" maxlength="9" v-focus :min="0"></el-input>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
        @pagination="getList" />
      <WorksDlog v-if="AddWorksFlag" :AddWorksFlag="AddWorksFlag" @NoneDlog="NoneDlog" @AddOk="AddOk" :editID="editID">
      </WorksDlog>
    </el-card>
  </div>
</template>

<script>
import { WorksListAPI } from '@/api/Works/WorkscCassify';
import { processErrors } from "@/utils/errorHandler";
import WorksDlog from "./component/WorksDlog.vue"

export default {
  components: {
    WorksDlog
  },
  data() {
    return {
      form: {
        name: ""
      },
      SearchFlag: false,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        name: ""
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
      },

      tableData: [],
      multipleSelection: [],
      dialogVisible: false,
      editID: "",
      // 总条数
      total: 0,
      AddWorksFlag: false,
      loading: false,
      clickText: "点击编辑",
      showWeight: {},
    };
  },
  created() {
    this.getList()
  },
  methods: {
    editShowWeight(index) {
      this.$set(this.showWeight, index, true); // 设置特定行的状态为 false
    },
    editWeight(index, data) {
      this.$set(this.showWeight, index, true); // 设置特定行的状态为 true
      if (data.sequence == null) {
        data.sequence = 0
      }
      let api = WorksListAPI()
      api.WorksAdded(data).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "修改成功",
            type: 'success'
          });
          this.$emit('AddOk');
          this.getList();
        } else {
          processErrors(res);
        }
      })
    },
    setToNumber(index) {
      for (let i = 0; i < this.total; i++) {
        this.$set(this.showWeight, i, true);
      }
      this.$set(this.showWeight, index, false); // 设置特定行的状态为 false
    
    },
    validateInput(row) {
      // 使用正则表达式验证输入值
      const regex = /^[0-9]*$/; // 只允许输入非负整数
      if (!regex.test(row.sequence)) {
        // 如果输入不符合要求，重置为0
        row.sequence = 0;
      }
    },
    getList() {
      this.loading = true
      let api = WorksListAPI()
      api.getWorksList(this.queryParams).then(res => {
        if (res.code == 0) {

          this.tableData = res.data.data
          this.total = res.data.totalCount
          for (let i = 0; i < this.total; i++) {
            this.$set(this.showWeight, i, true);
          }
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },

    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true
      } else {
        this.SearchFlag = false
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    search() {
      this.getList()
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        name: ""
      }
      this.getList()
    },
    addList() {
      this.editID = ""
      this.AddWorksFlag = true
    },
    NoneDlog() {
      this.AddWorksFlag = false
    },
    AddOk() {
      this.editID = ""
      this.AddWorksFlag = false
      this.getList()
    },
    addEdit(row) {
      this.editID = row.id
      this.AddWorksFlag = true
    },
  },
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector("input").focus();
      },
    },
  },
  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
  .custom-input ::v-deep .el-input__inner {
    text-align: center;
  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>